<template>
<!--	<div class="card p-shadow-2 p-p-3">
		<div class="card-header p-mb-2">
			{{ className }}
		</div>
		<div>
			<Chip class="chip-secondary" style="margin-right: 1rem">{{ currentCount }}</Chip>
			<template v-if="errorCount > 0">
				<Chip class="chip-danger">{{ errorCount }}</Chip>
			</template>
		</div>
	</div>-->
	<Card class="card">
		<template #title>
			<div style="height: 150px; overflow: hidden;">
				<svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%;">
					<path d="M0.00,92.27 C216.83,150.92 304.30,50 500.00,84 L500.00,0.00 L0.00,0.00 Z" style="stroke: none; fill: rgb(223, 223, 223);"></path>
				</svg>
			</div>
			<div class="p-grid">
				<div v-if="currentCount !== -1 || count !== -1" class="p-col-6 current-count">
					{{ count }}
				</div>
				<div v-if="errorCount > 0" class="p-col-4 p-text-right mdi mdi-alert-outline error-count">
					{{ errorCount }}
				</div>
			</div>
		</template>
<!--		<template #content>
			<div style="height: 150px; overflow: hidden; border: 1px solid black;">
				<svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%;">
					<path d="M0.00,92.27 C216.83,192.92 304.30,8.39 500.00,109.03 L500.00,0.00 L0.00,0.00 Z" style="stroke: none;fill: #e1efe3;"></path>
				</svg>
			</div>
		</template>-->
		<template #footer>
			<div class="name-overflow" v-tooltip.bottom="className">
				{{ className }}
			</div>
		</template>
	</Card>
</template>

<script lang="ts">
import Card from 'primevue/card';
import Tooltip from "primevue/tooltip";
import useSqueezeStore from "@/apps/squeeze/store";
import {defineComponent, onMounted, ref, watch} from "vue";
import {ClientManager} from "@/singletons/ClientManager";
import {ToastManager} from "@/util/ToastManager";
import {useI18n} from "vue-i18n";
import {useToast} from "primevue/usetoast";
import {defaultSort} from "@/util/SortingHelper";

export default defineComponent({
	name: "QueueNavigatorCard",
	components: {
		Card,
	},
	props: {
		className: {
			type: String,
			required: true,
		},
		currentCount: {
			type: Number,
			default: -1,
		},
		errorCount: {
			type: Number,
			default: -1,
		},
		docClassId: {
			type: Number,
			required: false,
		},
		searchRequestJson: {
			type: String,
			required: false,
		},
	},
	directives: {
		'tooltip': Tooltip,
	},
	setup(props) {
		const {t} = useI18n();
		const toast = useToast();

		/** Store */
		const store = useSqueezeStore();

		/** Current count of documents in a tile */
		const count = ref<number>(-1);

		/** Document API endpoint */
		const documentApi = ClientManager.getInstance().squeeze.document;

		/** Check global fontSize to fix the margin-top of counts
		 * Because we use the card, the count cannot be displayed in any other way and the font size must be observed.
		 */
		const checkFontSize = () => {
			const currentFontSize = store.state.userSettings.viewSettings.fontSize;
			if (currentFontSize === 0.7) {
				document.documentElement.style.setProperty('--element-margin-top', '-9rem');
			} else if (currentFontSize === 0.725) {
				document.documentElement.style.setProperty('--element-margin-top', '-8.75rem');
			} else if (currentFontSize === 0.75) {
				document.documentElement.style.setProperty('--element-margin-top', '-8.5rem');
			} else if (currentFontSize === 0.775) {
				document.documentElement.style.setProperty('--element-margin-top', '-8.25rem');
			} else if (currentFontSize === 0.8) {
				document.documentElement.style.setProperty('--element-margin-top', '-8rem');
			} else if (currentFontSize === 0.825) {
				document.documentElement.style.setProperty('--element-margin-top', '-7.75rem');
			} else if (currentFontSize === 0.85) {
				document.documentElement.style.setProperty('--element-margin-top', '-7.5rem');
			} else if (currentFontSize === 0.875) {
				document.documentElement.style.setProperty('--element-margin-top', '-7.25rem');
			} else {
				document.documentElement.style.setProperty('--element-margin-top', '-7rem');
			}
		}

		checkFontSize();

		/** Watch prop at set value object, because props are not allowed to be mutated */
		watch(() => store.state.userSettings.viewSettings.fontSize, () => {
			checkFontSize();
		})

		/**
		 * Get current count of documents in a search tile
		 * @param docClassId Current doc id of a tile
		 * @param searchRequest Current search request of a tile
		 */
		const getCurrentCount = (docClassId: number, searchRequest: any) => {
			documentApi.searchDocuments(docClassId, JSON.parse(searchRequest), 'index', 0, 25, [defaultSort])
				.then(result => {
					if (result && result.pagination.total) {
						count.value = result.pagination.total;
					}
					else if (result && result.elements && result.elements.length > 0) {
						count.value = result.elements.length;
					}
				}).catch((response: any) => response.json().then ((err: { message: string }) => {
					ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.General.Error') + ": " + err.message);
				}))
		}

		onMounted(() => {
			// check if docClassId and searchRequestJson is not undefined
			if (props.docClassId && props.searchRequestJson) {
				getCurrentCount(props.docClassId, props.searchRequestJson);
				return;
			}

			// check if currentCount exists
			if (props.currentCount) {
				count.value = props.currentCount;
				return;
			} else {
				// set default
				count.value = -1;
			}
		})

		return {
			count,
		}
	},
});

/*
@Options({

	watch: {
		'store.state.userSettings.viewSettings.fontSize': function() {
			this.checkFontSize();
		},
	},
})*/

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


/*.card {
	color: var(--dex-primary-color);
	border-radius: .25rem;
	cursor: pointer;
	height: 100%;
	word-wrap: break-word;
	display:flex;
	flex-direction:column;
	justify-content: space-between;
}

.card-header {
	font-size: 1.25rem;
}*/

.card {
	background-color: var(--dex-primary-color);
	color: #fff;
	cursor: pointer;
}

.p-card .p-card-title div div {
	font-size: 2rem;
	font-weight: 100;
}

::v-deep(.p-card-footer) {
	font-size: 1.5rem;
}

::v-deep(div.name-overflow) {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	color: var(--dex-text-color);
}

::v-deep(.p-card-title) {
	margin-top: -1rem;
	margin-left: -1rem;
	margin-right: -1rem;
}

::v-deep(.p-card-content) {
	display: none;
}

::v-deep(.p-card-footer) {
	padding: 0;
}

.current-count {
	margin-top: var(--element-margin-top);
	color: var(--dex-primary-color);
	margin-left: 1rem;
}

.error-count {
	color: var(--error-color);
	margin-top: var(--element-margin-top);
	padding-right: 1.5rem;
	width: 100%;
	font-family: var(--font-family);
}

</style>
